// Konvencia pre content: <a href="#opencookiesettings"> = nastavenia cookies.
// iOS appka (o súhlase rozhoduje ATT, Cookiebot UI je tam skryté) → natívne iOS
// Nastavenia appky (OPEN_APP_SETTINGS — prepínač Sledovanie; prepnutie appku
// zabije, stav sa zosynchronizuje na ďalšom cold starte cez app-att-cookiebot).
// Web + Android appka → Cookiebot dialóg znova (Cookiebot.renew()).
// Delegované na document, funguje aj pre dynamicky pridané linky (napr. z CMS
// obsahu). Vzor: rajhraciek resources/js/common/cookie-settings-link.ts.
// Bridge cez window.AppBridge (app-bridge.js) — musí sa importovať PO ňom.

const LINK_SELECTOR = 'a[href*="#opencookiesettings"]';

const openCookieSettings = async () => {
    const bridge = window.AppBridge;

    if (bridge && bridge.isApp) {
        try {
            const status = await bridge.callBridge("ATT_STATUS");

            if (status && status.status !== "notSupported") {
                await bridge.callBridge("OPEN_APP_SETTINGS");

                return;
            }
        } catch (error) {
            console.warn("[cookie-settings-link] Bridge zlyhal, fallback na Cookiebot:", error);
        }
    }

    if (window.Cookiebot && typeof window.Cookiebot.renew === "function") {
        window.Cookiebot.renew();
    }
};

document.addEventListener("click", (event) => {
    const link = event.target instanceof Element ? event.target.closest(LINK_SELECTOR) : null;

    if (!link) {
        return;
    }

    event.preventDefault();
    openCookieSettings();
});
